"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCategoryGroupsFailureAction = exports.createCategoryGroupsSuccessAction = exports.createCategoryGroupsAction = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const actionHelpers_1 = require("companion-app-components/flux/core/actionHelpers");
const errorPayloadCreator = (0, actionHelpers_1.getPayloadCreator)();
const categoryGroupsPayloadCreator = (0, actionHelpers_1.getPayloadCreator)();
exports.createCategoryGroupsAction = (0, toolkit_1.createAction)('CREATE_CATEGORY_GROUPS', categoryGroupsPayloadCreator);
exports.createCategoryGroupsSuccessAction = (0, toolkit_1.createAction)('CREATE_CATEGORY_GROUPS_SUCCESS', categoryGroupsPayloadCreator);
exports.createCategoryGroupsFailureAction = (0, toolkit_1.createAction)('CREATE_CATEGORY_GROUPS_FAILURE', errorPayloadCreator);
